import { render, staticRenderFns } from "./issueList.vue?vue&type=template&id=39a82c4c&scoped=true"
import script from "./issueList.vue?vue&type=script&lang=js"
export * from "./issueList.vue?vue&type=script&lang=js"
import style0 from "./issueList.vue?vue&type=style&index=0&id=39a82c4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a82c4c",
  null
  
)

export default component.exports